import type { GameState } from './types';

const STORAGE_KEY = 'powerstoneapp:state:v1';

/** 端末ローカル日付を 'YYYY-MM-DD' 形式で取得 */
export function todayLocalDate(now: Date = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** 2つの日付文字列の差を日数で返す(前日が負) */
function daysBetween(a: string, b: string): number {
  const da = new Date(`${a}T00:00:00`).getTime();
  const db = new Date(`${b}T00:00:00`).getTime();
  return Math.round((db - da) / 86400000);
}

export function createInitialState(now: Date = new Date()): GameState {
  return {
    inventory: [],
    daily: {
      date: todayLocalDate(now),
      consecutiveDays: 1,
      gachaUsed: false,
      tapUsed: false,
      shopRefillUsed: false,
      energy: 0,
    },
    selectedStoneId: null,
  };
}

/** 起動時に呼び、日次リセットと連続ログイン日数の更新を行う */
export function checkDailyReset(state: GameState, now: Date = new Date()): GameState {
  const today = todayLocalDate(now);
  if (state.daily.date === today) {
    return state;
  }
  const diff = daysBetween(state.daily.date, today);
  let consecutiveDays: number;
  if (diff === 1) {
    // 連続ログイン維持
    consecutiveDays = state.daily.consecutiveDays + 1;
  } else {
    // 1日以上空いた → リセット
    consecutiveDays = 1;
  }
  return {
    ...state,
    daily: {
      date: today,
      consecutiveDays,
      gachaUsed: false,
      tapUsed: false,
      shopRefillUsed: false,
      // エネルギーは持ち越し
      energy: state.daily.energy,
    },
  };
}

export function loadState(): GameState | null {
  if (typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as GameState;
    if (!parsed.daily || !Array.isArray(parsed.inventory)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveState(state: GameState): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // quota exceeded等は黙殺(個人アプリのため)
  }
}

export function clearState(): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.removeItem(STORAGE_KEY);
}
